import 'css-chunk:src/applications/GroupContentApp/SubmittedContent/components/Preview/Preview.module.scss';export default {
  "Preview": "_Preview_1xvlm_1",
  "content": "_content_1xvlm_1",
  "caption": "_caption_1xvlm_5"
};